import React, { useEffect, useRef, useState } from 'react';

import { selectSubscriptionPlan } from '../../core/requests/requests';
import { CloseIcon } from '../../assets';
import { PaymentsMethods } from '../../pages/settings/paymentsComponents';
import useOutsideClick from '../../hooks/useOutsideClicks';
import { Bounce, ToastContainer, toast } from 'react-toastify';

interface AddPaymentMethodModal {
  closeModal: () => void;
  selectedSubscriptionPlanId: string;
  handleFinishSetup: () => void;
}

const AddPaymentMethodModal: React.FC<AddPaymentMethodModal> = ({
  closeModal,
  selectedSubscriptionPlanId,
  handleFinishSetup,
}) => {
  const [loading, setLoading] = useState(false);
  const [subscriptionPlanId, setSubscriptionPlanId] = useState<string>('');
  const [discountCode, setDiscountCode] = useState<string>('');
  const addPaymentModalRef = useRef<HTMLDivElement>(null);
  useOutsideClick(addPaymentModalRef, () => closeModal());

  useEffect(() => {
    setSubscriptionPlanId(selectedSubscriptionPlanId);
  }, [selectedSubscriptionPlanId]);

  const handleSelectSubscriptionPlan = async () => {
    try {
      if (subscriptionPlanId) {
        setLoading(true);
        const { data } = await selectSubscriptionPlan(
          subscriptionPlanId
        );
        if (data) {
          window.open(data.invoiceHosted, '_blank');
          handleFinishSetup();
          closeModal();
          setLoading(false);
        }
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  const handleChangeDiscountCode = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDiscountCode(e.target.value);
  };

  const handleApplyDiscountCode = () => {
    // if(subscriptionPlanId == 'aa3f0410-6d16-11f0-88b6-efc6b6eb24dd' && discountCode == 'AstreauxW0r1D21') {
    if(discountCode == 'AstreauxW0r1D21') {
      if(subscriptionPlanId == 'aa3f0410-6d16-11f0-88b6-efc6b6eb24dd')
        setSubscriptionPlanId('8216b7b0-08d1-11f1-b893-1d305be0b56e');
      toast.success('Discount code applied successfully');
    } else {
      toast.error('Invalid discount code', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        });
    }
  };

  return (
    <div
      className="d-flex-start-start w-44rem bg-white p-1_5rem shadow-box-11 b-radius-0_75rem max-h-90vh overflow-auto align-items-center" style={{alignItems: 'center'}}
      ref={addPaymentModalRef}
    >
      <div className="d-flex-row-space-between w-100 mb-1rem">
        <span className="ff-inter c-111928 fw-700 fs-1_25rem">
          Select Payment Method
        </span>
        <div className="d-flex-center icon-hovered" onClick={closeModal}>
          <CloseIcon />
        </div>
      </div>
      <div className="d-flex-row-space-between gap-1_5px w-75 mb-1rem">
        <label className="ff-inter c-111928 fw-700 fs-0_25rem">
          Discount code
        </label>
        <input className="w-100 p-0 leads-search-input" style={{margin: '0rem 1rem', textAlign: 'center', padding: '0px'}} type="text" placeholder="Enter discount code" value={discountCode} onChange={handleChangeDiscountCode}/>
        <button className="btn-subscriptions-secondary w-10rem" onClick={handleApplyDiscountCode}>Apply</button>
      </div>
      <PaymentsMethods
        handleSelectSubscriptionPlan={handleSelectSubscriptionPlan}
        isModal={true}
        loading={loading}
      />
      <ToastContainer />
    </div>
  );
};

export default AddPaymentMethodModal;
